var map = {
	"./makhana-himalayan-salt (1).png": 8499,
	"./makhana-himalayan-salt (2).png": 5538,
	"./makhana-himalayan-salt (3).png": 8345,
	"./makhana-himalayan-salt (4).png": 4520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 388;